import { cn } from "@/lib/utils";
import { getTransactionStatusLabel } from "./utils";

type Props = {
	status: string;
	transactionType: string;
	className?: string;
	size?: "sm" | "md";
};

function getStatusBadgeStyles(status: string): string {
	switch (status) {
		case "PENDING_REVIEW":
		case "PENDING":
			return "bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-200/70";
		case "APPROVED":
		case "CAPTURED":
			return "bg-primary-50 text-primary-700 ring-1 ring-inset ring-primary-100";
		case "REFUNDED":
		case "PARTIALLY_REFUNDED":
			return "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200/70";
		case "VOIDED":
		case "REVERSED":
		case "CANCELED":
		case "DECLINED":
		case "REJECTED":
			return "bg-red-50 text-utility-red ring-1 ring-inset ring-red-200/70";
		default:
			return "bg-primary-50 text-primary-600 ring-1 ring-inset ring-primary-100";
	}
}

const TransactionStatusBadge = ({
	status,
	transactionType,
	className,
	size = "sm",
}: Props) => {
	const label = getTransactionStatusLabel(transactionType, status);

	if (!label) return null;

	return (
		<span
			className={cn(
				"inline-flex shrink-0 items-center rounded-full font-semibold leading-none",
				size === "sm" && "px-2.5 py-1 text-xs",
				size === "md" && "px-3 py-1.5 text-sm",
				getStatusBadgeStyles(status),
				className,
			)}
		>
			{label}
		</span>
	);
};

export default TransactionStatusBadge;
